import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from './pages/Home';
import Article from './pages/Article';
import ArticleList from './components/ArticleList';
import Editing from './pages/Editing';
import Login from './pages/Login';
import Flashcards from './pages/Flashcards';
import DeckCards from './pages/DeckCards';
import ReadCardPage from './pages/cards/read'; // Add this import
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import NavBar from './components/NavBar';
import { SpecialismProvider, specialismCodeMap } from './contexts/SpecialismContext';

const allowedSpecialismCodes = Object.keys(specialismCodeMap);

const App: React.FC = () => {
  return (
    <AuthProvider>
      <SpecialismProvider>
        <Router>
          <NavBar />
          <div>
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/cards/:deck/read" component={ReadCardPage} />
              <Route path="/cards/:deck" component={DeckCards} />
              <Route path="/cards" exact component={Flashcards} />
              <Route
                path="/:specialismCode/:id"
                render={props => {
                  const { specialismCode } = props.match.params;
                  if (!allowedSpecialismCodes.includes(specialismCode)) {
                    return <Home />;
                  }
                  return <Article {...props} specialismCode={specialismCode} />;
                }}
              />
              <Route path="/login" component={Login} />
              <ProtectedRoute path="/editing" component={Editing} />
            </Switch>
          </div>
        </Router>
      </SpecialismProvider>
    </AuthProvider>
  );
};

export default App;